




























































 import {Component, Watch, Prop} from 'vue-property-decorator';
 import {CardForm} from '@/components/bwaff';
import { SubscriptionApi } from '../api';
 import PaymentStatusMixin from '@/views/layout/navigation/mixins/payment-status-mixin';
 import { mixins } from 'vue-class-component';

 @Component({
   components: {
     CardForm,
   }
 })
 export default class Payment extends mixins<PaymentStatusMixin>(PaymentStatusMixin) { 
   get customer() {
     return this.$store.state.billingCustomer || {
       paymentMethod:{
         card:''
       }
     }
   }
   open_payment() {
     this.bus.emit('open-dialog', { name: 'UpdatePaymentMethodDialog' });
   }

   open_billing() {
     this.bus.emit('open-dialog', { name: 'UpdateBillingInfoDialog' });
   }
 }

